import { UserTypeEnum } from '~/models';
import { tempMeeApi } from '~/services/api';

export interface ISetUserTypeArgs {
  userType: UserTypeEnum;
  accessToken: string;
}

export const setUserType = async ({ userType, accessToken }: ISetUserTypeArgs): Promise<void> => {
  await tempMeeApi.patch(
    '/auth-service/users',
    { userType },
    { headers: { Authorization: accessToken } },
  );
};
